module.exports = __webpack_public_path__ + "img/fax-scan-no.afe71c8a.svg";